export default "__VITE_ASSET__BFSeFfOU__"